import { ChartArea } from 'chart.js';
import { Palette } from '@infoods/lifebase-ui';

type DrawDashLineOptions = {
  pointX: number;
  pointY: number;
  gapFromStart: number;
};

export const drawDashLine = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
  options: DrawDashLineOptions,
  palette: Palette,
) => {
  const { bottom } = chartArea;
  const { pointX, pointY, gapFromStart } = options;

  const isInChartArea = pointY + gapFromStart < bottom;

  if (isInChartArea) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(pointX, pointY + gapFromStart);
    ctx.lineTo(pointX, bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = palette.natural[400];
    ctx.setLineDash([5, 5]);
    ctx.stroke();
    ctx.restore();
  }
};
